module.exports = __webpack_public_path__ + "static/media/seaweedsalad.c909d623.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/toppings/seaweedsalad.jpg
// module id = 133
// module chunks = 0